import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { NotificationCard } from 'framework/ui/layout';
import { PROJECT_NOTIFICATION_TYPE } from './constants';
import { ProjectNotificationType } from './types';

type ProjectNotificationButtonProps = {
  onClick?: () => void;
  project: ProjectNotificationType;
  description?: string;
  actionLabel?: string;
};

const ProjectNotificationButton = ({
  onClick,
  project,
  description = 'Open project details',
  actionLabel = 'Open project',
}: ProjectNotificationButtonProps) => {
  const isWarning = project.type === PROJECT_NOTIFICATION_TYPE.WARNING;

  return (
    <NotificationCard
      onClick={onClick}
      title={String(project.message)}
      description={description}
      actionLabel={actionLabel}
      {...(isWarning ? { accentColor: 'warning.main', accentSoftColor: 'background.warning' } : {})}
      icon={
        isWarning ? (
          <WarningAmberRoundedIcon sx={{ fontSize: 18 }} />
        ) : (
          <NotificationsActiveOutlinedIcon sx={{ fontSize: 18 }} />
        )
      }
    />
  );
};

export default ProjectNotificationButton;
